import { Component, Shark, Utils } from "shark-mvc";
import { Modal } from "bootstrap";

import User from "../../models/User";
import UserPermission from "../../models/UserPermission";

import templateContent from "./project-settings-modal.html";

import userManager from "../../controllers/userManager";
import userPermissionManager from "../../controllers/userPermissionManager";

class ProjectSettingsComponent extends Component {
	constructor () {
		super("projectSettingsComponent");
		this.addTemplate("", templateContent);
	}

	afterLoad () {
		const modalNode = document.querySelector("#projectSettingsModal");

		if (modalNode) {
			this.modal = new Modal(modalNode, {
				keyboard: false
			});
		}
	}

	afterRender () {
		const allActivityPermissionsChk = document.querySelector(`[data-sh-prop="__allActivityPermissions"]`);

		if (allActivityPermissionsChk) {
			const { editingSettingsProject } = Shark.get();
			if (editingSettingsProject) {
				allActivityPermissionsChk.indeterminate = editingSettingsProject.__allActivityPermissionsIndeterminate;
			}
		}

		const allTaskPermissionsChk = document.querySelector(`[data-sh-prop="__allTaskPermissions"]`);

		if (allTaskPermissionsChk) {
			const { editingSettingsProject } = Shark.get();
			if (editingSettingsProject) {
				allTaskPermissionsChk.indeterminate = editingSettingsProject.__allTaskPermissionsIndeterminate;
			}
		}
	}
	
	close () {
		if (this.modal) {
			this.modal.hide();
			this.set("open", false);
		}

		Shark.set({
			userAssigningPermissions: null,
		});
	}

	closeProjectSettingsModalBtn_clickHandler () {
		this.close();
	}
	
	async init () {
		this.set("open", false);

		const { otherUserList } = Shark.get();

		if (!otherUserList || otherUserList.length === 0) {
			const userListResponse = await userManager.getList();
			const otherUserList = Shark.getInstanceList(User, userListResponse.data.filter(item => item.guid !== Shark.$store.loggedUser.guid));

			// otherUserList.forEach(item => item.cssClasses = "");

			Shark.set({
				otherUserList,
				saveButtonStatusCSSClass: "btn-primary",
			});
		}

		Shark.set({
			editingSettingsProject: null,//Questo non triggera il render, perchè?
		});
	}
	
	async open (project) {
		const projectPermissionResponse = await userPermissionManager.getListByProjectGuid(project.guid);
		const permissionMap = new Map();

		projectPermissionResponse.data.forEach(item => {
			permissionMap.set(item.userGuid, new UserPermission(item));
		});

		project.set({
			__userAccessPermissions: permissionMap,
		});

		Shark.set({
			editingSettingsProject: project,//Questo non triggera il render, perchè?
			saveButtonStatusCSSClass: "btn-secondary disabled",
		});
		Shark.render();

		if (this.modal) {
			this.modal.show();
			this.set("open", true);
		}
	}

	async saveProjectPermissions () {
		const { editingSettingsProject } = Shark.get();

		if (editingSettingsProject) {
			Shark.set({
				saveButtonStatusCSSClass: "btn-warning disabled",
			});
			
			const userPermissions = Array.from(editingSettingsProject.__userAccessPermissions.values());
			console.log({userPermissions});

			const saveResponse = await userPermissionManager.saveMulti(userPermissions);
			console.log({saveResponse});

			Shark.set({
				saveButtonStatusCSSClass: "btn-success",
			});
			setTimeout(() => {
				Shark.set({
					saveButtonStatusCSSClass: "btn-primary",
				});
				this.close();
			}, 1000);
		}
	}

	saveProjectPermissionsBtn_clickHandler () {
		this.saveProjectPermissions();
	}

	selectSingleUserBtn_clickHandler (event, data) {
		const userGuid = data.guid;
		const user = Utils.safp(Shark.$store.userList, "guid", userGuid);

		if (user) {
			const { editingSettingsProject, otherUserList } = Shark.get();

			otherUserList.forEach(item => item.cssClasses = item.guid === userGuid ? "bg-light" : "");

			Shark.set({
				saveButtonStatusCSSClass: "btn-primary",
				userAssigningPermissions: user,
			});
			editingSettingsProject.checkPermissionForUser();

			Shark.render();
		}
	}
}

const projectSettingsComponent = new ProjectSettingsComponent();

Shark.registerComponent(projectSettingsComponent);

export default projectSettingsComponent;
